import React from "react";
import { HubTableHeader } from "../../components";

const required = true;

export const items = [
  {
    id: "station",
    label: "Station",
    required,
  },
  {
    id: "quantity",
    label: "Quantity",
  },
  {
    id: "completed",
    label: "Completed",
  },
  {
    id: "scrapped",
    label: "Scrapped",
  },
  {
    id: "plannedStartDate",
    label: "Planned Start",
    required,
  },
  {
    id: "plannedEndDate",
    label: "Planned End",
    required,
  },
  {
    id: "startDate",
    label: "Actual Start",
  },
  {
    id: "endDate",
    label: "Actual End",
  },
];

export const WorkOrderRoutingHeader = ({ showQuantity = false }) => {
  const MENU = showQuantity
    ? items
    : items?.filter(({ id }) => id != "quantity");
  return (
    <HubTableHeader
      items={MENU}
      sx={{ backgroundColor: "hubColors.greyLighter" }}
    />
  );
};
